export default "__VITE_ASSET__b6ySyr20__"